import {apiSlice} from './apiSlice';

// Define a service using a base URL and expected endpoints
export const sessionTypeApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSessionTypes: builder.query({
      query: ({providerId, id}) => {
        const qs = new URLSearchParams('');
        if (id) qs.set('id', id);
        if (providerId) qs.set('provider_id', providerId);
        return `session_type/?${qs}`;
      },
      providesTags: ['SessionType'],
    }),
    createSessionType: builder.mutation({
      query: body => ({
        url: 'session_type/',
        method: 'POST',
        body
      }),
      invalidatesTags: ['SessionType', 'Availability', 'Provider'],
    }),
    updateSessionType: builder.mutation({
      query: ({ id, body }) => ({
        url: `session_type/${id}/`,
        method: 'PUT',
        body: body,
      }),
      invalidatesTags: ['SessionType', 'Session', 'Availability', 'Provider'],
    }),
    removeSessionType: builder.mutation({
      query: ({ id }) => ({
        url: `session_type/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['SessionType', 'Session', 'Availability', 'Provider'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetSessionTypesQuery,
  useCreateSessionTypeMutation,
  useUpdateSessionTypeMutation,
  useRemoveSessionTypeMutation
} = sessionTypeApi;
